module.exports = __webpack_public_path__ + "img/_supports.704ad897.png";